import styled from 'styled-components'

import { TdsDivider } from '@scania/tegel-react'
import type { BlockProps } from './block.types'

export const StyledBlock = styled.div<Pick<BlockProps, 'disablePadding'>>`
  ${({ disablePadding }) => disablePadding && 'padding: 0;'};
`

export const StyledDivider = styled(TdsDivider)`
  margin: var(--tds-spacing-layout-16) 0;
`

export const Header = styled.h6.attrs({
  className: 'tds-headline-06'
})`
  margin: 0;
`
